// @flow

import React from "react";
import ReactDOM from "react-dom";

import 'react-table/react-table.css';
import 'react-tabs/style/react-tabs.css';
import 'react-widgets/dist/css/react-widgets.css';
import "./index.css";
import "./c3jscustom.css";

import App from "./App.react";

const rootElement = document.getElementById("root");

if (rootElement) {
  ReactDOM.render(<App />, rootElement);
} else {
  throw new Error("Could not find root element to mount to!");
}



// WEBPACK FOOTER //
// ./src/index.js